import React, {Component} from 'react'
import { withHandlers, compose, defaultProps, pure } from 'recompose'
import { ProdibiStyle } from './../styles'
import withScript from './../hoc/withScript'

if (!window.prodibiAsync) {
  window.prodibiAsync = [{
    type: 'settings',
    settings: {
      account: 'richardmille'
    }
  }]
}

class Prodibi extends Component{
  state = {
    disabledTap : false
  }

  handlerClick = () => {
    this.setState({ disabledTap : true })
  }

  render () {
    const { 
      className, 
      onMount, 
      id, 
      width, 
      height, 
      heightMode, smartX, smartY, mediaView, mode, noTap  } = this.props
    return (
      <div ref={onMount} className={ ProdibiStyle(window.innerWidth / 2, window.innerHeight - 160) }>
        { !this.state.disabledTap && !noTap && (
            <div className="prodibi-tap">Tap to zoom in</div>
          )
        }
        <canvas
          className="prodibi-picture"
          data-prodibi={JSON.stringify({
            id: id,
            width: width,
            height: height,
            heightMode: heightMode,
            smartX: smartX,
            smartY: smartY,
            mediaView: mediaView,
            mode: mode
          })}
          onClick={ this.handlerClick }
        />
      </div>
    )
  }
}

const enhance = compose(
  withHandlers({
    onMount: () => node => {
      window.prodibiAsync.push({
        type: 'renderAll',
        elements: node
      })
    }

  }),
  defaultProps({
    className: '',
    heightMode: null,
    smartX: 0.5,
    smartY: 0.666667,
    mediaView: null,
    mode: 'zoom'
  }),
  withScript(
    'https://max1.prodibicdn.com/libraries/pages/prodibi.embed.1.2.min.js',
    <p>Loading...</p>
  ),
  pure
)

export default enhance(Prodibi)



// WEBPACK FOOTER //
// ./src/components/Prodibi.js